import React from 'react'
import {Link} from 'react-router-dom'
import Component from '../../components/Component'
import InfoTooltip from "../../components/InfoTooltip";
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import {Badge} from "antd";


const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

export default class OppPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        };
    }

    /*
    |--------------------------------------------------------------------------
    | Rendering Components
    |--------------------------------------------------------------------------
    */
    translate(key) {
        return TB.trans(`talent.talent_dashboard.panel_${key}`);
    }

    render() {
        let {opportunity, showStatus} = this.props;

        let statusLabelStyles = {},
            statusColor = opportunity.statusColor(),
            statusClass = opportunity.statusClass();

        let statusStyles = {
            background: statusColor,
            color: 'white',
            flex: 1
        };

        statusLabelStyles = {...statusStyles};
        delete statusLabelStyles.flex;
        statusLabelStyles.padding = '5px';
        statusLabelStyles.textAlign = 'center';
        statusLabelStyles.fontSize = '14px';

        let steps = opportunity.talentSteps();

        return (
            <div className='opportunity-panel'>

                {showStatus && (
                    <div className="panel-status">
                        <div style={{background: statusColor}}>
                            <h5>
                                {opportunity.displayStatus().toUpperCase()}
                            </h5>
                        </div>
                    </div>
                )}

                <div className="panel-info" style={{borderTopColor: statusColor}}>
                    <div className="py-3 px-4">

                        <div className="opportunity-client-row">

                            <div className="opportunity-client-logo">
                                <img
                                    src={opportunity.client?.logo_path || TB.logoImagePath()}
                                    alt={opportunity.client?.name}/>


                            </div>
                            <div className="client-name">
                                <p>
                                    {opportunity.client?.name}

                                    {opportunity.isAvailable() && !opportunity.hasSignedContract() && opportunity.project.is_on_hold && (
                                        <span className="opp-on-hold-panel" id={`oppHold${opportunity.id}`}>
                                            <i className="far fa-pause-circle"/>
                                            On Hold
                                        </span>
                                    )}

                                    {opportunity.isAvailable() && !opportunity.hasSignedContract() && opportunity.project.is_on_hold && (
                                        <InfoTooltip placement="top" type="primary" target={`oppHold${opportunity.id}`}>
                                            {TB.get(laravel.alerts, 'talent.opportunity_disabled_project_on_hold')?.message}
                                        </InfoTooltip>
                                    )}
                                </p>

                            </div>
                            {opportunity.isAvailable() && !opportunity.hasSignedContract() && !opportunity.project.is_on_hold && (
                                <span className="opp-unseen-update-panel">

                                    {opportunity.hasUnseenUpdate() && (
                                        <span>
                                            <i className="fas fa-exclamation-circle"/>
                                            Brief Updated
                                        </span>
                                    )}

                                    {opportunity.canMessageAndAcceptInterviews() && (
                                        <div className="flex can-message-and-accept-interviews gap-4">
                                            <div>
                                                <Badge size="small" overflowCount={9} count={opportunity.unread_messages_count || 0}>
                                                    <Link
                                                        className="btn btn-link btn-link-primary position-relative"
                                                        to={{
                                                            pathname: opportunity.proposalLink(),
                                                            search: `?tabView=messages`
                                                        }}
                                                        id="messages-tooltip"
                                                    >
                                                        <i className="far fa-comment-alt"/>
                                                    </Link>
                                                </Badge>


                                                <InfoTooltip
                                                    placement="top"
                                                    type={'gray'}
                                                    target={`messages-tooltip`}
                                                >
                                                    Messages
                                                </InfoTooltip>
                                            </div>


                                            <div>
                                                <Badge overflowCount={9} size="small" count={opportunity.proposed_meetings_count || 0}>
                                                    <Link
                                                        className="btn btn-link btn-link-primary position-relative"
                                                        to={{
                                                            pathname: opportunity.proposalLink(),
                                                            search: `?tabView=interviews`
                                                        }}
                                                        id="interviews-tooltip"
                                                    >
                                                        <i className="far fa-calendar-alt"/>
                                                    </Link>
                                                </Badge>
                                                <InfoTooltip
                                                    placement="top"
                                                    type={'gray'}
                                                    target={`interviews-tooltip`}
                                                >
                                                    Interviews
                                                </InfoTooltip>
                                            </div>
                                        </div>
                                    )}


                                </span>
                            )}
                        </div>


                        <div className="opportunity-panel-title">
                            <Link to={opportunity.detailLink()}>
                                {opportunity.displayName()}
                            </Link>
                        </div>


                        <LinesEllipsis
                            className="opportunity-panel-project-title"
                            component="p"
                            text={opportunity.project.name}
                            maxLine={1}
                        />

                        {!this.props.auth?.isTalentSupplierResource() && (
                            <>
                                <p className="opportunity-panel-label">
                                    Estimated Fee
                                </p>

                                <p className="opportunity-panel-value">
                                    {opportunity.estimatedFee()}
                                </p>
                            </>
                        )}
                        <p className="opportunity-panel-label">
                            Timeline
                        </p>

                        <p className="opportunity-panel-subvalue">
                            {opportunity.panelTimeDisplay()}
                        </p>


                        {this.props.auth?.isTalentSupplierResource() && opportunity.detailedViewAvailable() && (
                            <div className="py-3">
                                <Link
                                    to={opportunity.detailLink()}
                                    className={TB.mapClass(
                                        'opportunity-panel-steps-btn btn btn-block', {
                                            [`btn-${opportunity.statusClass()}`]: !opportunity.project.is_on_hold,
                                            'btn-disabled text-white': opportunity.project.is_on_hold
                                        })
                                    }
                                    onClick={event => {
                                        if (opportunity.project.is_on_hold) {
                                            event.stopPropagation();
                                            event.preventDefault();
                                            return TB.sysAlert('talent.opportunity_disabled_project_on_hold')
                                        }
                                    }}>
                                    View Details
                                </Link>
                            </div>
                        )}

                        {!this.props.auth?.isTalentSupplierResource()
                            && opportunity.detailedViewAvailable()
                            && !opportunity.hasSignedContract() && (
                                <div className="opportunity-step-container">
                                    {steps.map((step, index) => {

                                        if (step.isActive) {
                                            return (
                                                <Link
                                                    to={opportunity.detailLink()}
                                                    className={TB.mapClass(
                                                        'opportunity-panel-steps-btn btn btn-block', {
                                                            [`btn-${opportunity.statusClass()}`]: !opportunity.project.is_on_hold,
                                                            'btn-disabled text-white': opportunity.project.is_on_hold
                                                        })
                                                    }
                                                    onClick={event => {
                                                        if (opportunity.project.is_on_hold) {
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                            return TB.sysAlert('talent.opportunity_disabled_project_on_hold')
                                                        }
                                                    }}
                                                    key={`opp-${opportunity.id}-shop-steps-${index}` || `opp-${opportunity.id}-view-btn`}>
                                                    {`Step ${index + 1}. ${step.name}`}
                                                </Link>
                                            )
                                        }

                                        return (
                                            <p className={"opportunity-panel-steps-text " + (
                                                step.isComplete && 'complete '
                                            )}
                                               key={`opp-${opportunity.id}-shop-steps-${index}`}>
                                                Step {index + 1}.
                                                <b>{step.name}</b>
                                                <i className={step.isComplete ?
                                                    "fas fa-check text-success" :
                                                    "fas fa-chevron-right"}/>
                                            </p>
                                        );
                                    })}
                                </div>
                            )}


                        {(opportunity.hasSignedContract()
                            || opportunity.isActive() || opportunity.isCompleted()
                        ) && (
                            <Link to={`/${this.props.auth.talentPortalType()}/project/${opportunity.id}/review-contract`}
                                  className={`opportunity-panel-steps-btn
                                      btn btn-${statusClass} btn-block`}>
                                Review Contract
                            </Link>
                        )}

                        <div className="opportunity-panel-footer">

                            <div className="opp-footer-type">
                                {opportunity.displayType()}
                            </div>
                            {opportunity.isProposingAsIndividual() && (
                                <div className="opp-footer-type text-secondary">
                                    {/* {opportunity.is_fixed_fee_contract ? 'Fixed Fee' : 'Time & Materials'} */}
                                    {opportunity.project_position.contractTypeName()}
                                    {!!opportunity.project_position.isFixedRetainer() && (<span className="capitalize"> - {opportunity.project_position.payout_frequency}</span>)}
                                </div>
                            )}

                            {opportunity.isProposingWithTeam() && opportunity.team && (
                                <button className="btn btn-link no-click">
                                    {opportunity.team.name}
                                </button>
                            )}


                        </div>
                    </div>

                </div>
            </div>
        );
    }
}